import React, {Component} from 'react';
import ListDesignerHoc from "../../../../../../HocHelpers/ListDesignerHoc";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FormField from "../../../../../../Utils/Form/Fields/FormField";
import {Tooltip} from "@material-ui/core";
import ColorPickerPopover from "../../../../../../Utils/ColorPickerPopover";
import {chartColors} from "../../../../../../Utils/ChartUtils/chartColors";
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary} from "../../../../../../Utils/ExpansionPanel";
import {multiLanguageValue} from "../../../../../JsonScreen/Utils/lib";

const styles = () => ({
    table: {
        width: '100%',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    panelDetails: {
        padding: '0',
        display: 'block'
    },
    switchWrapper: {
        paddingLeft: 10
    }
});

class PieRechartForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: [
                {label: "Legend", name: "legend", fields: {
                        enable: {
                            type: "switch",
                            name: "enable",
                            path: "enable"
                        },
                        position: {
                            type: "autocomplete",
                            name: "position",
                            label: "Position",
                            path: "position",
                            options: [
                                {label: "Left", value: 'left'},
                                {label: "Center", value: 'center'},
                                {label: "Right", value: 'right'}

                            ]
                        },
                        direction: {
                            type: "autocomplete",
                            name: "direction",
                            label: "Direction",
                            path: "direction",
                            options: [
                                {label: "Row", value: 'horizontal'},
                                {label: "Column", value: 'vertical'},
                            ]
                        },
                        verticalAlign: {
                            type: "autocomplete",
                            name: "verticalAlign",
                            label: "Vertical Align",
                            path: "verticalAlign",
                            options: [
                                {label: "Top", value: 'top'},
                                {label: "Middle", value: 'middle'},
                                {label: "Bottom", value: 'bottom'},
                            ]
                        },
                        translateY: {
                            type: "number",
                            name: "translateY",
                            label: "Translate Y",
                            path: "translateY",
                        },
                        translateX: {
                            type: "number",
                            name: "translateX",
                            label: "Translate X",
                            path: "translateX",
                        },
                        itemWidth: {
                            type: "number",
                            name: "itemWidth",
                            label: "Item Width",
                            path: "itemWidth",
                        },
                        itemHeight: {
                            type: "number",
                            name: "itemHeight",
                            label: "Item Height",
                            path: "itemHeight",
                        }
                    }},
            ],
            series: [
                {
                    label: "Series", name: "series", fields: {
                        serie: {
                            type: 'autocomplete',
                            name: "column",
                            label: "Serie",
                            path: "column",
                        },
                        color: {
                            type: 'colorPicker',
                            name: "color",
                            label: "Color",
                            path: "color",
                            menu: [{label: "RED", value: 'red'}]
                        }

                    },
                },
            ],
            margins: [
                {
                    label: "Margins", name: "margins", fields: {
                        top: {
                            type: "number",
                            name: "top",
                            label: "Top",
                            path: "top",
                        },
                        right: {
                            type: "number",
                            name: "right",
                            label: "Right",
                            path: "right",
                        },
                        bottom: {
                            type: "number",
                            name: "bottom",
                            label: "Bottom",
                            path: "bottom",
                        },
                        left: {
                            type: "number",
                            name: "left",
                            label: "Left",
                            path: "left",
                        },

                    },
                },
            ],
            anchorColorPicker: null
        }
    }

    setAnchorColorPicker = (e) => {
        this.setState({anchorColorPicker: e.currentTarget})
    };

    pieForm = () => {
        const {fields} = this.state;
        const {classes, data, chartPropsChange, chartPropsChangeAutoComplete} = this.props;
        return (
            fields.map((item) => {
                return (
                    <ExpansionPanel key={item.label}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.heading}>{item.label}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails classes={{root: classes.panelDetails}}>
                            <table className={classes.table}>
                                <tbody>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        Enable
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.enable}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.enable.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.position.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.position}
                                                   onChangeAutoComplete={chartPropsChangeAutoComplete}
                                                   values={data}
                                                   options={item.fields.position.options}
                                                   path={`chartProps.${item.name}.${item.fields.position.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.direction.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.direction}
                                                   onChangeAutoComplete={chartPropsChangeAutoComplete}
                                                   options={item.fields.direction.options}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.direction.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.verticalAlign.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.verticalAlign}
                                                   onChangeAutoComplete={chartPropsChangeAutoComplete}
                                                   options={item.fields.verticalAlign.options}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.verticalAlign.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.translateY.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.translateY}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.translateY.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.translateX.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.translateX}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.translateX.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.itemWidth.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.itemWidth}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.itemWidth.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.itemHeight.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.itemHeight}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.itemHeight.path}`}/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )
            })
        )
    };

    series = () => {
        const {series, anchorColorPicker} = this.state;
        const {
            classes,
            chartChangeSeries,
            changeSerieColor,
            currentSerie,
            pivotData,
            listData: {content = []},
            data: {chartProps: {labelColumn}},
            userLanguage
        } = this.props;
        let newColumns = [];
        let valueSuggestions = (pivotData && pivotData.length > 0) ? pivotData : content;
        valueSuggestions.forEach(el => {
            if(el[labelColumn] !== 'Grand Total') {
                const multiLanguageLabel = multiLanguageValue(el[labelColumn], userLanguage)
                newColumns.push({label: multiLanguageLabel, value: el[labelColumn]})
            }
        });
        return (
            series.map((item) => {
                return (
                    <ExpansionPanel key={item.label}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.heading}>{item.label}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails classes={{root: classes.panelDetails}}>
                            <table className={classes.table}>
                                <tbody>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.serie.label}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.serie}
                                                   onChange={chartChangeSeries}
                                                   path={item.fields.serie.path}
                                                   options={newColumns}
                                                   values={currentSerie}
                                                   onChangeAutoComplete={chartChangeSeries}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        {item.fields.color.label}
                                    </td>
                                    <td className={classes.tableCell} style={{paddingLeft: 10, paddingTop: 3}}>
                                        {currentSerie ? (
                                            <>
                                                <div style={{
                                                    padding: '5px',
                                                    background: '#fff',
                                                    borderRadius: '1px',
                                                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                                                    display: 'inline-block',
                                                    cursor: 'pointer',
                                                }} onClick={(e) => this.setAnchorColorPicker(e)}>
                                                    <Tooltip title={'Select Color'}>
                                                        <div style={{
                                                            width: '36px',
                                                            height: '14px',
                                                            borderRadius: '2px',
                                                            background: currentSerie.color || 'rgba(0,0,0,1)'
                                                        }}/>
                                                    </Tooltip>
                                                </div>
                                                <ColorPickerPopover
                                                    open={Boolean(anchorColorPicker)}
                                                    close={() => this.setState({anchorColorPicker: null})}
                                                    complete={changeSerieColor}
                                                    type={"block"}
                                                    path={`chartProps.series.${currentSerie.index}.color`}
                                                    colors={chartColors}
                                                    anchorEl={anchorColorPicker}
                                                    color={currentSerie.color}
                                                />
                                            </>
                                        ) : <span>Select serie</span>}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )
            })
        )
    };

    margins = () => {
        const {margins} = this.state;
        const {classes, data, chartPropsChange} = this.props;
        return (
            margins.map((item) => {
                return (
                    <ExpansionPanel key={item.label}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.heading}>{item.label}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails classes={{root: classes.panelDetails}}>
                            <table className={classes.table}>
                                <tbody>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        Top
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.top}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.top.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        Right
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.right}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.right.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        Bottom
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.bottom}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.bottom.path}`}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.tableCellLabel}>
                                        Left
                                    </td>
                                    <td className={classes.tableCell}>
                                        <FormField field={item.fields.left}
                                                   onChange={chartPropsChange}
                                                   values={data}
                                                   path={`chartProps.${item.name}.${item.fields.left.path}`}/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )
            })
        )
    }

    render() {
        return (
            <>
                {this.pieForm()}
                {this.series()}
                {this.margins()}
            </>

        );
    }

}

export default ListDesignerHoc(withStyles(styles)(PieRechartForm))